import { atom } from 'recoil';

export interface DiceBonus {
	key?: string;
	name: string;
	operation: string;
	value: string | number | boolean;
	errorRange?: number;
}

export interface SelectedDie {
	notation: number;
	color?: string;
	label?: string;
}

export interface DiceResultEntry {
	id: string;
	notation: number;
	value: number;
	type: string;
	date: number;
	repeatable?: boolean;
	color?: string;
	label?: string;
}

export interface AlienPushContext {
	retainedSuccesses: number;
	retainedDiceEntries: DiceResultEntry[];
	rerollDice: SelectedDie[];
	pushed: boolean;
}

export interface AlienRollContext {
	mode: 'skill' | 'panic';
	stressLevel: number;
	sourceSummary?: string;
	sourceLabel?: string;
	sourceSuccessCount?: number;
	sourcePanic?: boolean;
	sourceWasPushed?: boolean;
}

export const dicesSelectedState = atom({
	key: 'dicesSelectedState',
	default: [] as Array<number | SelectedDie>,
});

export const dicesBonusListState = atom<DiceBonus[]>({
	key: 'dicesBonusListState',
	default: [],
});

export const customDicesState = atom({
	key: 'customDicesState',
	default: [],
});

export const customDiceSelectedState = atom({
	key: 'customDiceSelectedState',
	default: '',
});

export const isNextDiceExplosiveState = atom({
	key: 'isNextDiceExplosiveState',
	default: false,
});

export const isNextDiceRepetitionState = atom({
	key: 'isNextDiceRepetitionState',
	default: false,
});

export const repeatDicesState = atom({
	key: 'repeatDicesState',
	default: false,
});

export const alienPushContextState = atom<AlienPushContext | null>({
	key: 'alienPushContextState',
	default: null,
});

export const alienRollContextState = atom<AlienRollContext | null>({
	key: 'alienRollContextState',
	default: null,
});

export const areRulesOpenState = atom({
	key: 'areRulesOpenState',
	default: false,
});

export const diceRollMetaState = atom<{label: string; value: number;  } | null>({
	key: 'diceRollMetaState',
	default: null,
  });
